import React from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import CreativeCardsCommon from './themeCards';

const CreativeCardsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Creative Card' parent='Bonus Ui' title='Creative Card' />
      <Row>
        <CreativeCardsCommon />
      </Row>
    </Container>
  );
};
export default CreativeCardsContainer;
